import {createSelector} from '@ngrx/store';
import {filterReportItems} from '../reports.helpers';
import {reportsFeature} from './reports.reducer';

export const selectNearExpiryItems = reportsFeature.selectNearExpiryItems;
export const selectRecentChanges = reportsFeature.selectRecentChanges;
export const selectNearExpiryLoading = reportsFeature.selectNearExpiryLoading;
export const selectRecentChangesLoading = reportsFeature.selectRecentChangesLoading;
export const selectNearExpiryError = reportsFeature.selectNearExpiryError;
export const selectRecentChangesError = reportsFeature.selectRecentChangesError;
export const selectEffectiveTimeZoneId = reportsFeature.selectEffectiveTimeZoneId;
export const selectLastLoadedLocalDate = reportsFeature.selectLastLoadedLocalDate;

export const selectExpiringSoonItems = createSelector(
  selectNearExpiryItems,
  (items) => filterReportItems(items, 'expiring'),
);

export const selectExpiredItems = createSelector(
  selectNearExpiryItems,
  (items) => filterReportItems(items, 'expired'),
);

export const selectExpiringSoonCount = createSelector(selectExpiringSoonItems, (items) => items.length);
export const selectExpiredCount = createSelector(selectExpiredItems, (items) => items.length);
export const selectRecentEvents = reportsFeature.selectRecentEvents;
export const selectRecentChangesCount = createSelector(selectRecentEvents, (items) => items.length);
